import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router';
import { useUserCustomers } from '../customers/use-user-customers';
import { useTrustedPublishingStatus } from '../trusted-publishing/use-trusted-publishers';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
const SETTINGS_TABS = [
    { value: 'profile', label: 'Profile', icon: _jsx(PersonOutlinedIcon, {}) },
    { value: 'tokens', label: 'Access Tokens', icon: _jsx(KeyOutlinedIcon, {}) },
    { value: 'trusted-publishers', label: 'Trusted Publishers', icon: _jsx(VerifiedUserOutlinedIcon, {}) },
    { value: 'extensions', label: 'Extensions', icon: _jsx(GridViewOutlinedIcon, {}) },
    { value: 'customers', label: 'Rate Limiting', icon: _jsx(SpeedOutlinedIcon, {}) }
];
/**
 * The settings tabs applicable to the current user: Rate Limiting only for customer members, and
 * Trusted Publishers only where the registry has the feature on. An idle or failed status query
 * leaves `enabled` undefined, so the gate fails closed.
 */
export const useSettingsTabs = () => {
    const hasCustomers = (useUserCustomers().data ?? []).length > 0;
    const trustedPublishingEnabled = useTrustedPublishingStatus().data?.enabled ?? false;
    const isApplicable = (tab) => {
        switch (tab.value) {
            case 'customers':
                return hasCustomers;
            case 'trusted-publishers':
                return trustedPublishingEnabled;
            default:
                return true;
        }
    };
    return SETTINGS_TABS.filter(isApplicable);
};
/** Active settings tab; deep routes carry no :tab param, so derive it from what they do carry. */
export const useActiveSettingsTab = () => {
    const { tab, namespace, extension } = useParams();
    if (tab != null) {
        return tab;
    }
    if (extension != null) {
        return 'extensions';
    }
    if (namespace != null) {
        return 'namespaces';
    }
    return undefined;
};
//# sourceMappingURL=settings-tabs.js.map